import BottomHeader from './BottomHeader';
import MobileMenu from './MobileMenu';
import TopHeader from './TopHeader';
import useHeader from './useHeader';

const Header = () => {
  const { labels, data, locales, currentLocale, menuIsOpen, toggleMenu } = useHeader();
  return (
    <>
      <TopHeader
        topHeaderMenu={data?.topHeaderMenu}
        topHeaderItems={data?.topHeaderItems}
        locales={locales}
        currentLocale={currentLocale}
      />
      <BottomHeader
        appLogo={data?.appLogo?.data?.attributes}
        appLogoUrl={data?.appLogoUrl ?? '/'}
        bottomHeaderMenu={data?.bottomHeaderMenu}
        menuItems={data?.menuItem}
        toggleMenu={toggleMenu}
        cartButtonLabel={labels?.['cartButton']}
        userButtonLabel={labels?.['userButton']}
        menuButtonLabel={labels?.['menuButton']}
      />
      {menuIsOpen && (
        <MobileMenu
          menuItems={data?.menuItem}
          topHeaderMenu={data?.topHeaderMenu}
          topHeaderItems={data?.topHeaderItems}
          toggleMenu={toggleMenu}
          locales={locales}
          currentLocale={currentLocale}
          backButtonLabel={labels?.['backButton']}
          closeButtonLabel={labels?.['closeButton']}
        />
      )}
    </>
  );
};
export default Header;
